"use strict";

var FunnelSelectFilterActions = require("app/shared/actions/funnel-select-filter-actions");
var FunnelSelectFilterStore = require("app/shared/stores/funnel-select-filter-store");
var Dropdown = require("app/shared/components/Dropdown/dropdown");
var _ = require("underscore");

var FunnelSelectFilter = React.createClass({
  mixins: [Reflux.ListenerMixin],
  getInitialState: function() {
    var initialState = FunnelSelectFilterStore.state;

    initialState.selected = this.props.filters
      ? this.props.filters.selectedFunnel
      : null;

    return initialState;
  },
  getDefaultProps: function() {
    return ({ showDefaultOption: true });
  },
  componentDidMount: function(){
    this.listenTo(FunnelSelectFilterStore, this.setState);
    FunnelSelectFilterActions.loadFunnels();
  },
  handleChange: function(obj) {
    this.props.setFilter("funnel", obj.value);

    this.setState({
      selected: obj.value
    });
  },
  buildFunnelOptions: function() {
    var funnelOptions = _.map(this.state.funnels, function(funnel){
      return { id: funnel.id, name: funnel.name };
    })

    return funnelOptions;
  },
  getOptions: function() {
    var options = this.props.showDefaultOption
      ? [{ id: "", name: "Todos os funis" }]
      : [];

    options = options.concat(
      this.buildFunnelOptions()
    );

    return options;
  },
  render: function() {
    return(
      <div className={`userSelect-filter fs-14 ${this.props.className}`}>
        <Dropdown ref="funnel"
          handleCustomChange={this.handleChange}
          value={this.state.selected}
          options={this.getOptions()}
          className="b-light"
          parentClassName="d-b"
        />
      </div>
    );
  }
});

module.exports = FunnelSelectFilter;



// WEBPACK FOOTER //
// ./app/shared/components/FunnelSelectFilter/funnel-select-filter.jsx